import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { FlagsSidebar } from "@/feature-flags/flags-sidebar";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from "vue-i18n";

const i18nInstance = createI18n({
  legacy: false,
  locale: AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
  fallbackLocale: "id",
  globalInjection: false,
  messages: {
    en,
    id,
    my
  }
});
const translate = i18nInstance.global.t;

const MappingFeatureName = {
  Dashboard: "Beranda",
  Tracking: "Lacak Pengiriman",
  Booking: "Daftar Booking",
  "Bulk Booking": "Booking Bulk",
  "Manual STT": "Manual STT",
  "Cetak Tagihan": "Cetak Tagihan",
  "Cetak Resi": "Cetak Resi",
  "CN Manifest": "CN Manifest",
  "Pesanan Kulioner": "Pesanan Kulioner",
  "On Process STT": "STT Dalam Proses",
  "Manajemen Kiriman Penting": "Kiriman Penting",
  "Permintaan Kiriman Penting": "Request HAL",
  "STT Paid/Unpaid": "STT Kurang Bayar",
  Pickup: "Proses PUP",
  "STI-SC": "Proses STI SC",
  "STO-SC": "Proses STO SC",
  STI: "Proses STI",
  Bagging: "Proses BAG",
  "Siap DiKargo": "Proses RTC",
  "Booking Cargo": "Proses CARGO",
  "Booking Kargo": "Proses CARGO",
  "STI DEST": "Proses STIDEST",
  "Delivery Manifest": "Delivery Manifest",
  Delivery: "Delivery",
  "POD/DEX": "POD/DEX",
  "In Out Hub": "Transfer Hub (IN OUT HUB)",
  Dispatch: "Proses DISPATCH",
  "Dispatch delivery": "Proses DISPATCH",
  Handover: "Handover Vendor (HND)",
  "Shortland Cargo": "STT Shortland",
  "Custom Status": "Proses Custom Status",
  "Dashboard DEX Asesmen": "Performa DEX Asesmen",
  "Dex Asesmen": "DEX Asesmen",
  "Daftar Tiket DEX": "Daftar DEX Asesmen",
  Rekonsiliasi: "Rekon Delivery",
  "Manajemen Pelanggan": "Manajemen Pelanggan",
  "Pos Langganan": "POS Langganan",
  "Manajemen Kurir": "Manajemen Kurir",
  "Daftar POS Cabang & Di Pickup": "Manajemen POS Cabang & Di-Pickup",
  "Pendaftaran & manajemen klien": "Manajemen Korporat",
  "Partner Management": "Manajemen Partner",
  "User Management": "Manajemen User",
  "Pusat Resolusi": "Pusat Resolusi",
  "Base rate": "Base Rate",
  "Konversi mata uang": "Konversi Mata Uang",
  "Configurable price": "Konfigurasi Harga",
  "Tarif komoditas": "Tarif Komoditas",
  "Pajak barang": "Pajak Barang",
  "Konfigurasi komisi": "Konfigurasi Komisi",
  "Promo Diskon": "Promo Diskon",
  "Konfigurasi COD": "Konfigurasi COD",
  Product: "Jenis Pengiriman",
  Komoditas: "Komoditas",
  Embargo: "Embargo",
  "Location Coverage": "Area Cakupan",
  "Leg Management": "Manajemen Leg",
  "Route Management": "Manajemen Rute",
  "Vendor Management": "Manajemen Vendor",
  "Transport Management": "Manajemen Moda",
  "Bagging Grouping": "Bagging Grouping",
  "Kargo Konfigurasi": "Konfigurasi Kargo",
  "Area keterlambatan": "Area Keterlambatan",
  "Dokumen internasional": "Dokumen Internasional",
  "Top Up Verification": "Verifikasi Top Up",
  "Top Up Approval": "Approval Top Up",
  "Manual Credit Debit": "Manual Transaksi",
  "Balance Limit Rule": "Konfigurasi Batas Saldo",
  "Saldo Terakhir": "Saldo Terakhir",
  "Transaksi Saldo Nett": "Transaksi Saldo Nett",
  "Denda Saldo Minus": "Konfigurasi Denda Saldo Minus",
  "Top Up & Cashback": "Konfigurasi Top Up & Cashback",
  "Konfigurasi Kuota Tiket CS": "Konfigurasi Kuota Tiket CS",
  "Automasi Indikasi DEX Palsu": "Automasi Indikasi DEX Palsu",
  "Incoming & Outgoing": "Incoming & Outgoing",
  Pengumuman: "Pengumuman",
  "Konfigurasi Pesan": "Konfigurasi Pesan",
  "Integration Monitoring": "Monitoring Integrasi API",
  Middleware: "Middleware",
  "CMS Banner": "Konfigurasi Banner",
  "Penghasilan COD": "Penghasilan COD",
  "Daftar Pick Up": "Daftar Pick Up",
  "Konfigurasi Jadwal": "Konfigurasi Jadwal Pick up",
  Integration: "Integrasi API",
  Laporan: "Laporan",
  Upload: "Unggah Data",
  Download: "Unduh Format & Data",
  "Berikan penilaian Anda": "Masukan & Saran",
  Notifikasi: "Notifikasi",
  Keluar: "Keluar",
  Akun: "Profil",
  "Hub to Hub": "Transfer Hub (IN OUT HUB)",
  "Balance Limit Rules": "Konfigurasi Batas Saldo",
  "Configurable Price": "Konfigurasi Harga",
  "STI SC": "Proses STI SC",
  "STI DEST-SC": "Proses STIDEST SC",
  "Customer Service L2": "DEX Asesmen L2",
  "Customer Service L1": "DEX Asesmen L1",
  "Client Management": "Manajemen Korporat",
  "Client Registration": "Manajemen Korporat",
  Klien: "Manajemen Korporat"
};

const updateFeatureName = (featureName: string) => {
  const mappingOldName: Record<string, string> = {};
  const isAccountInternal = AccountController.accountData.isInternalAccount;

  if (
    !MainAppController.isSidebarAndBreadcrumbV2 ||
    !FlagsSidebar.permission_sidebar_v2_enabled.isEnabled()
  ) {
    return mappingOldName[featureName] || featureName;
  }
  let newName =
    MappingFeatureName[featureName as keyof typeof MappingFeatureName];

  // 🔹 Daftar mapping khusus akun internal
  const internalAccountOverrides: Record<string, string> = {
    "Request HAL": "Kiriman Penting"
  };
  // kondisi jika akun internal
  if (isAccountInternal) {
    newName = internalAccountOverrides[newName] || newName;
  }
  // simpan mapping nama lama
  mappingOldName[newName] = featureName;
  return newName || featureName;
};

export const updateFeatureNameV2 = (featureName: string) => {
  return (
    MappingFeatureName[featureName as keyof typeof MappingFeatureName] ||
    featureName
  );
};

export default updateFeatureName;
